<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-alert v-if="error" tile type="error">{{ error }}</v-alert>
                <v-card-title>{{ formTitle }}</v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row dense>
                            <v-col cols="6" md="8">
                                <v-text-field
                                    v-model="editedItem.name"
                                    :counter="50"
                                    :rules="[rules.required]"
                                    label="Name*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-switch
                                    class="ml-4"
                                    v-model="editedItem.isPlaceholder"
                                    label="Placeholder"
                                    small
                                ></v-switch>
                            </v-col>
                            <!-- <v-col cols="12">
                                <v-text-field
                                    v-model="editedItem.description"
                                    :counter="500"
                                    label="Description"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col> -->
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.width"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Width*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.height"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Height*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.layoutX"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Left*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.layoutY"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Top*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>

                            <v-col class="mt-8" cols="12" sm="6" v-if="!editedItem.isPlaceholder">
                                <v-range-slider
                                    v-model="editedItem.temperatureRange"
                                    min="10,"
                                    max="40,"
                                    color="primary"
                                    track-color="grey lighten-2"
                                    prepend-icon="fa-thermometer-half"
                                    thumb-size="24"
                                    thumb-label="always"
                                    label="°C"
                                ></v-range-slider>
                            </v-col>
                            <v-col class="mt-8" cols="12" sm="6" v-if="!editedItem.isPlaceholder">
                                <v-range-slider
                                    v-model="editedItem.humidityRange"
                                    color="primary"
                                    track-color="grey lighten-2"
                                    prepend-icon="fa-tint"
                                    thumb-size="24"
                                    thumb-label="always"
                                    label="%"
                                ></v-range-slider>
                            </v-col>
                            <v-col class="ml-1" cols="12" sm="6" v-if="!editedItem.isPlaceholder">
                                <v-switch
                                    v-model="editedItem.pesticide"
                                    label="Pesticide"
                                    color="primary"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="close">Cancel</v-btn>
                    <v-btn outlined rounded :loading="isSaving" color="primary" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import helper from "@/utils/helper.js"
import Config from "@/utils/config.json";

export default {
    name: "greenhouse-department-edit-dialog",
    props: ["dialog", "greenhouseNodeId", "object"],
    components: {},
    data() {
        return {
            error: null,
            isSaving: false,
            isLoadingGreenhouses: false,
            editedItem: {
                id: "",
                greenhouseDepartmentNodeId: "",
                name: "",
                description: "",
                isPlaceholder: false,
                layoutX: 0,
                layoutY: 0,
                width: 10,
                height: 10,
                temperatureRange: [20, 30],
                humidityRange: [40, 60],
                pesticide: false
            },
            defaultItem: {
                id: "",
                greenhouseDepartmentNodeId: "",
                name: "",
                description: "",
                isPlaceholder: false,
                layoutX: 0,
                layoutY: 0,
                width: 10,
                height: 10,
                temperatureRange: [20, 30],
                humidityRange: [40, 60],
                pesticide: false
            },
            rules: {
                required: v =>
                    !helper.isEmpty(v) || "This field is required",
                minLength: len => v =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
            },
            greenhouseDialog: false
        };
    },
    computed: {
        meterToPixelRatio() {
            return Config.meterToPixelRatio;
        }, // 1 meter = 10 pixels
        formTitle() {
            return this.object ? "Edit Department" : "Add Department";
        }
    },
    watch: {
        // reset form when dialog open or close
        dialog(val) {
            this.resetForm();

            // if open dialog, initialize selections
            if (val) {
                this.initializeSelections();
            }
        }
    },
    methods: {
        initializeSelections() {
            // fetch greenhouses
            this.isLoadingGreenhouses = true;
            this.$store
                .dispatch("greenhouses/fetchGreenhouses")
                .then(() => {})
                .catch(error => {
                    /*handle errors*/
                    console.log(error);
                })
                .finally(() => (this.isLoadingGreenhouses = false));
        },

        resetForm() {
            // reset form state
            this.error = null;
            this.isSaving = false;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // when editing, set form with object
            if (this.dialog && this.object) {
                this.editedItem.id = this.object.id;
                this.editedItem.name = this.object.name;
                this.editedItem.description = this.object.description;
                this.editedItem.spaceM2 = this.object.spaceM2;
                this.editedItem.waterMm = this.object.waterMm;
                this.editedItem.temperatureRange = [
                    this.object.temperatureMin,
                    this.object.temperatureMax
                ];
                this.editedItem.humidityRange = [
                    this.object.humidityMin,
                    this.object.humidityMax
                ];
                this.editedItem.pesticide = this.object.pesticide;
            }
            // when new or closing, set form with default
            else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
        },

        close() {
            this.$emit("update:dialog", false);
            this.resetForm();
        },

        save() {
            // check if form valid
            if (!this.$refs.form.validate()) {
                return;
            }

            // set form state
            this.error = null;
            this.isSaving = true;

            // prepare api call payload
            var payload = {
                greenhouseNodeId: this.greenhouseNodeId,
                name: this.editedItem.name,
                description: this.editedItem.description,
                isPlaceholder: this.editedItem.isPlaceholder,
                layoutX: this.editedItem.layoutX * this.meterToPixelRatio,
                layoutY: this.editedItem.layoutY * this.meterToPixelRatio,
                width: this.editedItem.width * this.meterToPixelRatio,
                height: this.editedItem.height * this.meterToPixelRatio,
                temperatureMin: this.editedItem.temperatureRange[0],
                temperatureMax: this.editedItem.temperatureRange[1],
                humidityMin: this.editedItem.humidityRange[0],
                humidityMax: this.editedItem.humidityRange[1],
                pesticide: this.editedItem.pesticide
            };

            // edit
            if (this.object) {
                // prepare graphql mutation payload
                payload.id = this.editedItem.id;

                // update
                this.$store
                    .dispatch(
                        "greenhouseDepartments/updateGreenhouseDepartment",
                        payload
                    )
                    .then(response => {
                        // update parent object
                        this.$emit("update:object", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
            // new
            else {
                this.$store
                    .dispatch(
                        "greenhouseDepartments/createGreenhouseDepartment",
                        payload
                    )
                    .then(response => {
                        this.$emit("item-created", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors
                            .map(error => error.message)
                            .join(", ");
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>